import {WelcomeEmailSender} from "./common/WelcomeEmailSender";

window.addEventListener('load', () => {
    new WelcomeEmailSender()});